import { render, staticRenderFns } from "./BirimSecimiAnaBirim.vue?vue&type=template&id=1aba434a&"
import script from "./BirimSecimiAnaBirim.vue?vue&type=script&lang=js&"
export * from "./BirimSecimiAnaBirim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports